import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { openWhatsApp } from "@/lib/api";

export default function StickyWhatsApp() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const footer = document.querySelector("footer[data-testid='footer']");
    if (!footer) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { rootMargin: "0px 0px -10% 0px" }
    );
    observer.observe(footer);
    return () => observer.disconnect();
  }, []);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20 }}
          transition={{ duration: 0.4 }}
          onClick={() => openWhatsApp({ source: "sticky_floating" })}
          className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-40 wa-pulse rounded-full p-[2px] gradient-bg"
          data-testid="sticky-whatsapp-btn"
          aria-label="Chat on WhatsApp"
        >
          <span className="flex items-center gap-2 md:gap-3 pl-4 pr-5 md:pl-5 md:pr-6 py-3 md:py-3.5 rounded-full bg-void text-white text-sm font-medium">
            <span className="relative flex h-2.5 w-2.5">
              <span className="absolute inline-flex h-full w-full rounded-full bg-[#4FC3F7] opacity-75 animate-ping" />
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 gradient-bg" />
            </span>
            <span className="hidden sm:inline">Chat on WhatsApp</span>
            <span className="sm:hidden">WhatsApp</span>
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
}
